import { render, staticRenderFns } from "./StudentRejectsLesson.vue?vue&type=template&id=6818f5aa&"
import script from "./StudentRejectsLesson.vue?vue&type=script&lang=js&"
export * from "./StudentRejectsLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports